import React from 'react';
import './Footer.css';
import IFrameWidgetRenderer from '../iframe/IFrameWidgetRenderer';

const Footer = () => <IFrameWidgetRenderer id="supplier-search-pa-footer" iframeSrc="/PAFooter.jsp" />;

export default React.memo(Footer);
